export default __webpack_public_path__ + "static/media/img_contactUs.a07482ee.png";